import React from 'react'
import { findIndex } from 'lodash-es'

const CatalystProgressBar = ({ currentThemeId, availableThemes, handleClick, t }) => {
  const currentIndex = findIndex(availableThemes, (t) => t.id === currentThemeId)
  return (
    <div className="catalyst-progress">
      <label>{t('theme_nav_title')}</label>
      <div className="d-flex align-items-center justify-content-between progress-items-container">
        {availableThemes.map((theme, index) => (
          <div className={`progress-item-border ${currentIndex >= index && 'active'}`} key={index}>
            <div className="progress-item d-flex align-items-center justify-content-center" onClick={currentIndex >= index ? ()=>handleClick(theme.id) : undefined }>
              {index + 1}
            </div>
          </div>
        ))}
      </div>
      <div className="progress-line" />
    </div>
  )
}

export default CatalystProgressBar



// WEBPACK FOOTER //
// ./src/components/catalyst-progress-bar.js